export const UNCLASSIFIED_CAR_CLASS_ID = 'unclassified'

export function getDefaultExpandedCarClassIds(groups = []) {
  return groups
    .filter((group) => group.results.length > 0)
    .map((group) => group.id)
}

export function getStandingsClassTimingLeader(results = []) {
  return results.find((result) => result.status === 'finished') ?? null
}

function sortAdditionalGroups(left, right) {
  const leaderDifference =
    Number(left.results[0]?.racePosition ?? Number.MAX_SAFE_INTEGER) -
    Number(right.results[0]?.racePosition ?? Number.MAX_SAFE_INTEGER)

  return (
    leaderDifference ||
    (left.carClass?.name || '').localeCompare(right.carClass?.name || '')
  )
}

export function buildStandingsCarClassGroups({
  results = [],
  configuredCarClasses = [],
  includeUnclassified = false,
}) {
  const resultsByClassId = new Map()

  for (const result of results) {
    const classId = result.carClass?.id || UNCLASSIFIED_CAR_CLASS_ID
    const classResults = resultsByClassId.get(classId) ?? []
    classResults.push(result)
    resultsByClassId.set(classId, classResults)
  }

  const configuredClassIds = new Set(
    configuredCarClasses.map((carClass) => carClass.id),
  )
  const configuredGroups = configuredCarClasses.map((carClass) => ({
    id: carClass.id,
    carClass,
    results: resultsByClassId.get(carClass.id) ?? [],
  }))
  const additionalGroups = []
  const additionalClassIds = new Set()

  for (const result of results) {
    const carClass = result.carClass

    if (
      !carClass ||
      configuredClassIds.has(carClass.id) ||
      additionalClassIds.has(carClass.id)
    ) {
      continue
    }

    additionalClassIds.add(carClass.id)
    additionalGroups.push({
      id: carClass.id,
      carClass,
      results: resultsByClassId.get(carClass.id) ?? [],
    })
  }

  additionalGroups.sort(sortAdditionalGroups)

  const groups = [...configuredGroups, ...additionalGroups]
  const unclassifiedResults =
    resultsByClassId.get(UNCLASSIFIED_CAR_CLASS_ID) ?? []

  if (includeUnclassified && unclassifiedResults.length > 0) {
    groups.push({
      id: UNCLASSIFIED_CAR_CLASS_ID,
      carClass: null,
      results: unclassifiedResults,
    })
  }

  return groups
}
